import { TAdfoxRequestedParams } from '../../../types/adfox';
import { EActionTypes, TAdfoxParamsActions } from '../actions/actions';

export const adfoxParamsReducer = (
  state: TAdfoxRequestedParams | null = null,
  action: TAdfoxParamsActions,
): TAdfoxRequestedParams | null => {
  switch (action.type) {
    case EActionTypes.SetData:
      return action.payload;

    default:
      return state;
  }
};
